// extracted by mini-css-extract-plugin
export default {"header":"News_header__NALVa","heading":"News_heading__COqdZ","btn":"News_btn__EcqlK","arrow":"News_arrow__tfXo9","loadBtn":"News_loadBtn__6hvwF"};